import './Inventory.scss';
import { useTranslation } from 'react-i18next';
import SearchInput from '../../../components/SearchInput/SearchInput';
import PurchasePricesUploader from '../../PurchasePrices/PurchasePricesUploader';
import { useState } from 'react';
import LabelSwitch from '../../../components/LabelSwitch/LabelSwitch';
import { Loader } from '../../../components/Loader/Loader';
import { useLocation } from 'react-router-dom';
import InventoryTable, {
  inventoryfilterFn,
  InventoryItem,
  INVENTORY_ITEMS,
} from './InventoryTable';
import FeesTable, { feesfilterFn, FeesItem, FEES_ITEMS } from './FeesTable';
import { usePP } from '../../../context/pp-context';

export type SwitchLabelType = 'inventory' | 'fees';

export default function Inventory() {
  const { t } = useTranslation();

  const { countPP, isLoadingPP } = usePP();

  let location = useLocation();
  const params = new URLSearchParams(location.search);
  const type = params.get('type');

  const [selectedType, setSelectedType] = useState<SwitchLabelType>(
    type === 'fees' ? 'fees' : 'inventory'
  );

  const [inventoryItems, setInventoryItems] =
    useState<InventoryItem[]>(INVENTORY_ITEMS);

  const [feesItems, setFeesItems] = useState<FeesItem[]>(FEES_ITEMS);

  const [searchString, setSearchString] = useState('');

  let founded: any[] = searchString
    ? inventoryItems?.filter(inventoryfilterFn(searchString))
    : inventoryItems;

  if (selectedType === 'fees') {
    founded = searchString
      ? feesItems?.filter(feesfilterFn(searchString))
      : feesItems;
  }

  return (
    <div className='Page flex-grow-1'>
      {isLoadingPP && <Loader />}
      <div className='container d-flex justify-content-center'>
        <div className='Paper w-100 p-4 Paper--Inventory mx-auto'>
          {!!countPP && (
            <>
              <PurchasePricesUploader />
              <div
                className='Inventory__separator mx-n4'
                style={{
                  marginBottom: 32,
                }}
              />
            </>
          )}
          <div className='mb-3 d-flex align-items-center justify-content-between'>
            <div className='d-flex align-items-center'>
              <div className='Text--30 fw-900'>{t('Products')} 123</div>
              <LabelSwitch<SwitchLabelType>
                activeItem={selectedType}
                className='ms-4'
                onClick={(v) => () => {
                  setSelectedType(v);
                }}
                items={[
                  { value: 'inventory', label: t('Inventory') },
                  { value: 'fees', label: t('Fees') },
                ]}
              />
            </div>
            <SearchInput
              name='search'
              onChange={setSearchString}
              value={searchString}
              placeholder={t('Search')}
            />
          </div>
          {selectedType === 'inventory' ? (
            <InventoryTable
              items={founded || []}
              setItems={setInventoryItems}
            />
          ) : (
            <FeesTable items={founded || []} setItems={setFeesItems} />
          )}
        </div>
      </div>
    </div>
  );
}
